import { UtilityService } from "../services/UtilityService";
import { mapToNewPlan, NewPlanType, Plan, PlanType } from "./plans.model";

export class OrganizationModel {
    constructor() {
    }
    ID: string;
    Name: string;
    PhoneNumberCount: number;
    Reference: string;
    UserCount: number;
    IsDeleted: boolean;
    CreatedDateTime: string;
}

export const mapToOrganization = (x: any): OrganizationModel => {
    return {
        ID: x.id,
        Name: x.name,
        PhoneNumberCount: x.phones,
        Reference: x.reference,
        UserCount: x.users,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime
    } as OrganizationModel
}

export class OrganizationDetails {
    constructor() {

    }
    ID: string;
    Name: string;
    Email: string;
    ZipCode: string;
    Address: string;
    MobileNumber: string;
    Industry: string;
    HouseNumber: string;
    Reference: string;
    City: string;
    State: string;
    Country: string;
    IsNewSubFlow?: boolean
}

export const mapToOrganizationDetails = (x: any): OrganizationDetails => {
    return {
        ID: x.id,
        Name: x.name,
        Reference: x.reference,
        MobileNumber: x.number,
        Industry: x.industry || "0",
        Address: x.address,
        HouseNumber: x.aptNumber,
        City: x.city,
        ZipCode: x.zip,
        Email: x.email,
        State: x.state,
        Country: x.country,
        IsNewSubFlow: x.isNewSubFlow
    } as OrganizationDetails
}

export class NewOrganization {
    constructor() {
    }
    ID: string;
    Name: string;
    PhoneNumberCount: number;
    Reference: string;
    UserCount: number;
    IsDeleted: boolean;
    IsYearPlan: boolean;
    CreatedDateTime: string;
    SeatUsage: SeatUsage[];
}

export const mapToNewOrganization = (x: any): NewOrganization => {
    return {
        ID: x.id,
        Name: x.name,
        PhoneNumberCount: x.phones,
        Reference: x.reference,
        UserCount: x.users,
        IsDeleted: x.isDeleted,
        CreatedDateTime: x.createdDateTime,
        IsYearPlan: x.isYearPlan,
        SeatUsage: x.seatUsage.map(mapToSeatUsage)
    } as NewOrganization
}
export class OrgPlanHistory {
    constructor() {
    }
    CancelDate: string;
    CreatedDateTime?: string;
    EndDate: string;
    Id?: string;
    IsYearPlan: boolean;
    OrgId: string
    PlanId: string;
    PlanName: string;
    PlanType: PlanType;
    Quantity: number;
    RenewDate: string;
    StartDate: string;
    StatusType: number;
    SubscriptionId: string;
    Plan?: Plan;
    Price?: number;
    YPrice?: number;
    PlanGroupCredits?: number;
    TotalGroupCredits?: number;
}

export const MapToOrgPlanHistory = (x: any) => {
    return {
        CancelDate: !!x.cancelDate ? UtilityService.convertDateToDay(x.cancelDate) : "",
        CreatedDateTime: !!x?.createdDateTime ? UtilityService.convertDateToDay(x?.createdDateTime) : "",
        EndDate: !!x.endDate ? UtilityService.convertDateToDay(x.endDate) : "",
        Id: x?.id,
        IsYearPlan: x.isYearPlan,
        OrgId: x.organizationId,
        PlanId: x.planId,
        PlanName: x?.planName || x?.name,
        PlanType: x.planType,
        Quantity: x.quantity,
        RenewDate: !!x.renewDate ? UtilityService.convertDateToDay(x.renewDate) : "",
        StartDate: !!x.startDate ? UtilityService.convertDateToDay(x.startDate) : "",
        StatusType: x.statusType,
        SubscriptionId: x.subscriptionId,
        Plan: !!x.plan && mapToNewPlan(x?.plan),
        Price: x?.price,
        YPrice: x?.yPrice,
        PlanGroupCredits: x?.planGroupCredits,
        TotalGroupCredits: x?.totalGroupCredits
    } as OrgPlanHistory
}


export class BasicCountModel {
    constructor() { }
    Total: number;
    Addons: number;
    Used: number;
    AddonSettled: number;
}

export class SeatUsage {
    constructor() { }
    SeatType: string;
    PlanId: string;
    Users: BasicCountModel;
}
export class OrgAccountBilling {
    constructor() {
    }
    GroupMsgCredits: BasicCountModel;
    CurrentPlanDetails: OrgPlanHistory[];
    SeatUsage: SeatUsage[];
}

export const MapToOrgAccountBilling = (x) => {
    return {
        GroupMsgCredits: mapToBasicCountModel(x.groupMsgCredits),
        CurrentPlanDetails: x.currentPlanDetails.map(MapToOrgPlanHistory),
        SeatUsage: x.seatUsage.map(mapToSeatUsage)
    } as OrgAccountBilling
}

export const mapToSeatUsage = (x) => {
    return {
        SeatType: x.seatType,
        PlanId: x.planId,
        Users: mapToBasicCountModel(x.users)
    } as SeatUsage
}

export const mapToBasicCountModel = (x) => {
    return {
        Total: x.total,
        Used: x.used,
        Addons: x.addOns,
        AddonSettled: x.addonSettled
    } as BasicCountModel
}